<div class="flex flex-column">
  <form [formGroup]="userForm">
    <div class="flex grid m-0 align-items-center">
      <ls-form-field-molecule
        [labelText]="'Nombre'"
        [labelFor]="'nombre'"
        [required]="true"
        formName="nombre"
        [group]="userForm"
        class="col-6"
        [loading]="isLoading()">
      </ls-form-field-molecule>

      <ls-form-field-molecule
        [labelText]="'Apellidos'"
        [labelFor]="'apellidos'"
        formName="apellidos"
        [group]="userForm"
        class="col-6"
        [loading]="isLoading()">
      </ls-form-field-molecule>

      <div class="field col-6">
        <ls-label-atom
          [text]="'Teléfono'"
          [forId]="'telephone'"
          [class]="'mb-2 block'"
          [required]="true">
        </ls-label-atom>
        <input
          type="text"
          pInputText
          id="telephone"
          formControlName="telephone"
          class="w-full" />
      </div>

      <div class="field col-6">
        <ls-label-atom [text]="'DNI'" [forId]="'dni'" [class]="'mb-2 block'">
        </ls-label-atom>
        <input
          type="text"
          pInputText
          id="dni"
          formControlName="dni"
          class="w-full" />
      </div>

      <ls-form-field-molecule
        [labelText]="'Email'"
        [labelFor]="'email'"
        [required]="true"
        formName="email"
        [group]="userForm"
        class="col-12"
        [loading]="isLoading()">
      </ls-form-field-molecule>

      <div class="field col-12">
        <ls-label-atom
          [text]="'Dirección'"
          [forId]="'address'"
          [class]="'mb-2 block'">
        </ls-label-atom>
        <input
          type="text"
          pInputText
          id="address"
          formControlName="address"
          class="w-full" />
      </div>

      @if(assignedInstallationsCount === 1){
      <div class="field col-12 flex align-items-center gap-3 mt-2">
        <p-selectButton
          id="tipo"
          [options]="skipCorporateOptions"
          formControlName="skip_corporate_view"
          optionLabel="name"
          optionValue="code">
        </p-selectButton>
        <div class="flex flex-column">
          <ls-label-atom
            [text]="'Redirección directa a la Instalación'"
            [forId]="'directoCorporate'"
            [class]="'font-bold'">
          </ls-label-atom>
          <small class="text-secondary"
            >Si está activo, el usuario será redirigido directamente a la
            instalación que tenga assignada.</small
          >
        </div>
      </div>
      }
      <div class="field col-12">
        <ls-label-atom
          [text]="'Observaciones'"
          [forId]="'observations'"
          [class]="'mb-2 block'">
        </ls-label-atom>
        <textarea
          pTextarea
          id="observations"
          formControlName="observations"
          class="w-full"
          rows="3"></textarea>
      </div>

      <div class="field col-12">
        <ls-label-atom
          [text]="'Tipo usuario'"
          [forId]="'tipo'"
          [class]="'mb-2 block'"
          [required]="true">
        </ls-label-atom>

        @if (isLoading()) {
        <p-skeleton height="2rem"></p-skeleton>
        } @else {
        <p-selectButton
          id="tipo"
          [options]="roleOptions"
          formControlName="rol"
          optionLabel="name"
          optionValue="code">
        </p-selectButton>
        }
      </div>

      <div class="field col-12">
        <app-upload-images
          [placeholderContent]="'Haz clic o arrastra el logo aquí (Máx 1)'"
          [maxFiles]="1"
          [initialImages]="initialLogos"
          (onImagesChange)="handleImagesUpdate($event)">
        </app-upload-images>
      </div>
    </div>

    <ls-cancel-save-molecule
      (cancelClick)="closeDialog()"
      (saveClick)="saveUser()"
      [processing]="isSaving()" />
  </form>
</div>
